import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { AssetsData } from '@payments/common-utils';

import { DepositService } from '../../../service/deposit.service';
import { OptionListService } from '../../../service/optionList.service';
import { ResizeService } from '../../../service/resize.service';
import { UserDataService } from '../../../service/userDataService';

@Component({
    selector: 'app-deposit-declined',
    imports: [CommonModule, TranslateModule],
    templateUrl: './deposit-declined.component.html',
    styleUrl: './deposit-declined.component.scss',
})
export class DepositDeclinedComponent implements OnInit {
    userDataService = inject(UserDataService);
    private depositService = inject(DepositService);
    private optionListService = inject(OptionListService);
    private resizeService = inject(ResizeService);
    assetsData = inject(AssetsData);

    failureResponse: any;
    isMobile: boolean;
    btnData: any;
    constructor() {
        this.resizeService.resizeCashier();
    }
    ngOnInit(): void {
        this.failureResponse = this.depositService.submitResponse;
        const { activeRegisteredbankAccounts, bank_registration_allowed_count } = this.userDataService.userData.configParams;
        this.btnData =
            activeRegisteredbankAccounts < bank_registration_allowed_count
                ? {
                      content: 'PARTY.CASHIER.web.deposit.failure.managebankaccounts.registerbankaccount.btn',
                      type: 'bank-account-register/create',
                  }
                : { content: 'PARTY.CASHIER.web.deposit.bankregistration.managebank.button', type: 'manage-bank-accounts' };
    }
    redirectToMainCashier() {
        const typeParam = `&type=${this.btnData?.type}`;
        this.optionListService.redirectToMainCashier(typeParam);
    }
    goBackToDeposit() {
        this.depositService.showDepositInput.set(true);
        this.depositService.showDeclinePage.set(false);
        setTimeout(() => {
            this.resizeService.resizeCashier();
        }, 500);
    }
}
